import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpinstance } from "../../axios/api";
const initialState = {
  queryDetails: null,
  manualQuoteDetails : {},
  // When true, ManualQuoteHtmlUI renders the quote read-only (KAM "view" of an
  // already-submitted manual quotation) instead of the normal create/edit form.
  viewOnly: false
};


export const getAllOriginDestinationCharges = createAsyncThunk(
    'getAllOriginDestinationCharges',
    async (value, { rejectWithValue }) => {
        try {
            const response = await httpinstance.get("manual-quote/get-all-sw-charges");
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);


export const addManualQuote = createAsyncThunk(
  'addManualQuote',
  async (value, { rejectWithValue }) => {
      try {
          const response = await httpinstance.post("/manual-quote", value);
          return response?.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const getAllManualQuoteById = createAsyncThunk(
  'getAllManualQuoteById',
  async (id, { rejectWithValue }) => {
      try {
          const response = await httpinstance.get(`/manual-quote/get-manual-quote/${id}`);
          return response.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const getManualQuoteDetailById = createAsyncThunk(
  'getManualQuoteDetailById',
  async (id, { rejectWithValue }) => {
      try {
          const response = await httpinstance.get(`/manual-quote/get-manual-quote-detail/${id}`);
          return response.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const getManualQuoteHistory = createAsyncThunk(
  'getManualQuoteHistory',
  async (manualQuoteId, { rejectWithValue }) => {
      try {
          const response = await httpinstance.get(`/manual-quote/get-manual-quote-history/${manualQuoteId}`);
          return response.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);

export const editManualQuote = createAsyncThunk(
  'editManualQuote',
  async (value, { rejectWithValue }) => {
      try {
          const response = await httpinstance.put(`/manual-quote/${value.manualqueryId}`, value);
          return response?.data;
      } catch (err) {
          return rejectWithValue(err.response?.data || 'Something went wrong');
      }
  }
);


const manualQuoteSlice = createSlice({
  name: "manualQuoteSlice",
  initialState,
  reducers: {
    setQueryDetail(state, action) {
      // This is the "start a brand-new manual quote" action (dispatched by
      // semd_manualQuote for a Quote Pending/Auto Quoted query) — always
      // reset manualQuoteDetails/viewOnly too, otherwise whatever quote was
      // last viewed/edited in this session (a completely different query)
      // stays in redux and gets picked up by ManualQuoteHtmlUI's prefill
      // effect, making the new quote look pre-filled with someone else's rates.
      state.queryDetails = action.payload;
      state.manualQuoteDetails = {};
      state.viewOnly = false;
    },
    setManualQuoteDetail(state, action) {
      state.queryDetails = action.payload.queryDetails;
      state.manualQuoteDetails = action.payload.manualQuoteDetails
      state.viewOnly = !!action.payload.viewOnly
    },
    clearManualQuote(state , action){
      state.queryDetails = null
      state.manualQuoteDetails = {}
      state.viewOnly = false
    }
  },
});
export const { setQueryDetail, setManualQuoteDetail , clearManualQuote} = manualQuoteSlice.actions;
export default manualQuoteSlice.reducer;
